<svelte:options tag="lq-app" />
<script lang="ts">
  import Router from "svelte-spa-router";
  import Login from "./routes/Login.svelte";
  import AssessmentResults from "./routes/full/AssessmentResults.svelte";
  import Confirmation from "./routes/basic/Confirmation.svelte";
  import UserDetails from "./routes/UserDetails.svelte";
  import Hipaa from "./routes/Hipaa.svelte";
  import NotFound from "./routes/NotFound.svelte";
  import { registerDependencies } from "./DependencyRegistration"

  registerDependencies();
  
  const routes = {
    "/": Login,
    "/myanalysis/login": Login,
    "/myanalysis/assessmentresults": AssessmentResults,
    "/myanalysis/userdetails": UserDetails,
    "/myanalysis/hipaa": Hipaa,
    "/myanalysis/userdetails/confirm": Confirmation,
    "*": NotFound,
  };

</script>
<main>
  <Router {routes} />
</main>
<style type="scss" global>
@use "scss/global";
@use "../11ty/src/assets/css/bootstrap4.min.css";
@import "/build/bundle.css";
</style>
